import React from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { Breadcrumbs, P } from '../../AbstractElements';
import HeaderCard from '../Common/HeaderCard';
import { BasicExamplestext, Discription1, SampleCard } from '../../Constant';

const SamplePageContainer = ({ mainTitle, title, parent }) => {
  return (
    <Container fluid={true} className='fix-sample'>
      <Breadcrumbs pageTitle={mainTitle ? mainTitle : 'Sample Page'} title={title ? title : 'Sample Page'} parent={parent ? parent : 'Pages'} />
      <Row>
        <Col sm='12'>
          <Card>
            <HeaderCard title={SampleCard} span1={BasicExamplestext} />
            <CardBody>
              <P>{Discription1}</P>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
export default SamplePageContainer;
